// HussarAi changelog entries — newest first.
// Adding a new entry: prepend to the array. Slug must be unique.
// Types: "shipped" (new), "improved" (enhancement), "fixed" (bug).
//
// 2026-02-10 architecture reset: historical commercial lead-operator
// changelog entries were archived to /app/leadwing_extracted/frontend/
// data/changelog_leadwing.js so hussarai.org visitors don't see
// commercial-operator history under an institutional immigration-record
// brand. Restart from HussarAi's own milestones going forward.

export const CHANGELOG = [
  {
    date: "2026-02-10",
    slug: "architecture-reset",
    type: "improved",
    titlePl: "HussarAi wraca do jednej misji",
    titleEn: "HussarAi refocused on a single mission",
    bodyPl: "HussarAi to teraz wyłącznie europejska platforma spójności akt imigracyjnych. Komercyjne narzędzie operatora zostało wydzielone do osobnego produktu i zniknęło z nawigacji, sitemapy oraz analityki HussarAi. Doktryna pozostaje niezmieniona: AI przygotowuje. Człowiek decyduje. Każda akcja pozostawia ślad audytowy.",
    bodyEn: "HussarAi is now solely the European immigration-record integrity platform. The commercial operator tooling has been extracted into its own separate product and removed from HussarAi navigation, sitemap, and analytics. Doctrine is unchanged: AI prepares. Human authority decides. Every action leaves an audit trail.",
    tags: ["architecture", "doctrine"],
  },
];
